import { CheckCircle2, AlertTriangle, XCircle, MinusCircle, Circle, ShieldCheck, Cloud, Info } from "lucide-react";

// Severity-Töne → Farben (Badge-Darstellung). Status-Werte kommen aus dem Backend.
export const SEC_TONE = { safe: "#A3E635", warning: "#fbbf24", critical: "#f87171", info: "#38bdf8", neutral: "#6b7280" };

export const STATUS_META = {
  safe: { Icon: CheckCircle2, color: "#A3E635", label: "Sicher", tone: "safe" },
  alternative_active: { Icon: ShieldCheck, color: "#34d399", label: "Alternative aktiv", tone: "safe" },
  warning: { Icon: AlertTriangle, color: "#fbbf24", label: "Warnung", tone: "warning" },
  critical: { Icon: XCircle, color: "#f87171", label: "Kritisch", tone: "critical" },
  open: { Icon: MinusCircle, color: "#6b7280", label: "Offen", tone: "neutral" },
  optional_open: { Icon: Circle, color: "#60a5fa", label: "Optional offen", tone: "info" },
  not_configured: { Icon: Circle, color: "#9ca3af", label: "Nicht konfiguriert", tone: "neutral" },
  platform_managed: { Icon: Cloud, color: "#38bdf8", label: "Plattform-managed", tone: "info" },
  telemetry_missing: { Icon: Info, color: "#60a5fa", label: "Telemetrie nicht verbunden", tone: "info" },
  not_required: { Icon: MinusCircle, color: "#9ca3af", label: "Nicht erforderlich", tone: "neutral" },
  not_checkable: { Icon: Info, color: "#38bdf8", label: "Nicht direkt prüfbar", tone: "info" },
};

export const metaOf = (status) => STATUS_META[status] || STATUS_META.open;
